import {Route} from '@angular/router';
import {canActivateHasPermissionFn, canActivateLoggedInChild} from '@indosuara/auth';
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';

const developerPermission = 'dev:staff';

export const appRoutes: Route[] = [
  {
    path: '', redirectTo: '/remit', pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./login/login.component').then(
          (m) => m.LoginComponent,
      ),
  },
  {
    path: 'login/:redirectUrl',
    loadComponent: () =>
      import('./login/login.component').then(
          (m) => m.LoginComponent,
      ),
  },
  {
    path: 'remit',
    loadChildren: () =>
      import('@indosuara/remit').then(
          (m) => m.RemitModule,
      ),
    canActivate: [canActivateLoggedInChild],
  },
  {
    path: 'developer/basic',
    loadComponent: () =>
      import('./developer-page/developer-page.component').then(
          (m) => m.DeveloperPageComponent,
      ),
    canActivate: [
      canActivateLoggedInChild,
      canActivateHasPermissionFn(developerPermission),
    ],
  },
  {
    path: 'developer/audit-logs',
    loadComponent: () =>
      import('@indosuara/superadmin').then((m) => m.AuditLogsComponent),
    canActivate: [
      canActivateLoggedInChild,
      canActivateHasPermissionFn(developerPermission),
    ],
  },
  {
    path: 'developer/api-keys',
    loadComponent: () =>
      import('./developer-api-key-page/developer-api-key-page.component').then(
          (m) => m.DeveloperApiKeyPageComponent,
      ),
    canActivate: [
      canActivateLoggedInChild,
      canActivateHasPermissionFn(developerPermission),
    ],
  },
  {
    path: 'logout',
    loadComponent: () =>
      import('@indosuara/auth-ui').then(
          (m) => m.LogoutComponent,
      ),
    canActivate: [canActivateLoggedInChild],
  },
  {
    path: 'change-password',
    loadComponent: () =>
      import('@indosuara/auth-ui').then((m) => m.ChangePasswordComponent),
    canActivate: [canActivateLoggedInChild],
  },
  {
    path: '**', component: PageNotFoundComponent,
    canActivate: [canActivateLoggedInChild],
  },
];
